import { render, staticRenderFns } from "./OrganizationAssociation.vue?vue&type=template&id=0c402aa3&scoped=true&"
import script from "./OrganizationAssociation.vue?vue&type=script&lang=ts&"
export * from "./OrganizationAssociation.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationAssociation.vue?vue&type=style&index=0&id=0c402aa3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c402aa3",
  null
  
)

export default component.exports